import { selector } from 'recoil';
import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { type PetBreedDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/pet';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export const getPetBreedsSelector = selector<PetBreedDTO[]>({
    key: 'getPetBreedsSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const { flavourName } = get(getOnsaCurrentProductSelector);
        const isLoggedOn = get(isLoggedOnSelector);

        return await OnlineSalesUnauthenticated.getPetBreed(
            jobNumber,
            flavourName,
            sessionId,
            !isLoggedOn
        );
    }
});
